module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAFMN540AAAAAXNSR0IArs4c6QAAASRJREFUSA1jYKAVmD9/vgCtzAaZO2vWLE9amk+22XPnzlXHqxlZARO6yt+/f3egi4H5M2bMWI9VYrgIAj3ohRw0ZPmL7FRBVvDOmzdPiSxnjmoiIwSAUXSaDG0ILdOnTz+D4JHBooYBv7HZi1EMoCsC2twkLy/Pgy5OkA/SuGjRIm6CCtEVAEO7mSyNIIPI1ojuilH+aAgQHwKzZ8/Wo7gKAVrHSLyVCJWg+gvIa2RlZY1JTk6+iZAhnkWWxTDjQXXf379/m9nY2KJJdQBFFqM7gJ2dPTApKekxTBwfTbDkw6cZJpeWlrYdyN728+fPeTAxQjTFPgaVrIyMjLpcXFwxcXFxXwlZCJMn22JyLSTb4lWrVrG9e/duJak+hFk4So+cEAAAJrBhRn5VZkwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/live/calendar_right_btn.png
// module id = TlO3
// module chunks = 1